import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Button, Flex, StyledText } from 'src/components';
import { ButtonVariantsType } from '../../components/Button';
import { StyledTextVariantsTypeV2 } from '../../components/StyledText';

import Routes from '../../enums/routes';
import { NotFound404 } from 'src/assets/images/custom';
import { BiocerticaLogoWithTextDefaultHorizontal } from 'src/assets/images/logos';
import { translate } from '../../translations/translations';

const LogoContainer = styled.div`
    display: flex;
    height: 15vh;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    padding: 30px;
    box-sizing: border-box;
`;

const ContentContainer = styled.div`
    display: flex;
    width: 100%;
    height: 85vh;
    align-items: center;
    justify-content: center;
`;

const NotFoundBox = styled.div`
    display: flex;
    flex-direction: column;
    width: auto;
    height: auto;
    align-items: center;
    justify-content: center;
    padding: 30px;
    box-sizing: border-box;

    i {
        height: 100px;
        width: 100px;
        margin-bottom: 40px;
    }
`;

const NotFound = (): ReactElement => {
    const history = useHistory();

    return (
        <Flex flex={1} flexDirection="column" alignItems={'center'} justifyContent={'center'} height={'100%'}>
            <LogoContainer>
                <Link to={Routes.ROOT}>
                    <img src={BiocerticaLogoWithTextDefaultHorizontal} alt={'logo green'} />
                </Link>
            </LogoContainer>
            <ContentContainer>
                <NotFoundBox>
                    <img src={NotFound404} alt={'logo green'} />
                    <StyledText
                        text={translate('notFoundPage.title')}
                        textAlign={'center'}
                        variant={StyledTextVariantsTypeV2.PARAGRAPH_5}
                        margin={'0 0 24px 0'}
                    />
                    <StyledText
                        text={translate('notFoundPage.text')}
                        textAlign={'center'}
                        variant={StyledTextVariantsTypeV2.HEADING_5}
                    />
                    <Button
                        margin={'36px 0 0 0'}
                        variant={ButtonVariantsType.PRIMARY_GREEN}
                        text={translate('notFoundPage.button.text')}
                        width={'auto'}
                        onClick={() => {
                            history.push(Routes.ROOT);
                        }}
                    />
                </NotFoundBox>
            </ContentContainer>
        </Flex>
    );
};

export default NotFound;
